import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'

export const createProductRecommendation = async (payload) => {
  const response = await axios.post(
    CHAT_ENDPOINTS.createProductRecommendation,
    payload,
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    },
  )

  return response.data
}